import React, { useEffect, useMemo, useState } from "react";
import {
	FilterWrapper,
	AccordionWrapper,
	AccordionContainer,
	AccordionHeader,
	AccordionTitle,
	AccordionIcon,
	AccordionContent,
	SeeMoreButton,
} from "./SideBarfilterStyle";
import { Form, Spinner } from "react-bootstrap";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { min, orderBy } from "lodash";
import CloseIcon from "@material-ui/icons/Close";
import Switch from "react-switch";
import t from "../../i18n/translate";
import FlagIconFactory from "react-flag-icon-css";
import { Tune } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { resetFilters } from "../../store/actions/productAction";
import { useHistory,useParams,useLocation } from 'react-router-dom';

const FlagIcon = FlagIconFactory(React, { useCssModules: false });

const SidebarFilter = ({
	brands,
	products,
	setSelectedBrands,
	GetSub,
	// setSelectedCategory,
	isModal,
	ModalOpen,
	showModal,
	loading,
	query
}) => {
	const dispatch = useDispatch();
	const [initialMount, setMount] = useState(true);
	const [isFilter, setIsFilter] = useState(true);
	const [applyFilter, setApplyFilter] = useState(false);
	const [brandSelected, setBrandSelected] = useState([]);
	const [countrySelected, setCountrySelected] = useState([]);
	const [categorySelected, setCategorySelected] = useState([]);
	const [subCategorySelected, setSubCategorySelected] = useState([]);
	const [dietarySelected, setDietarySelected] = useState([]);
	const [accordion1Open, setAccordion1Open] = useState(true);
	const [accordion2Open, setAccordion2Open] = useState(true);
	const [accordion3Open, setAccordion3Open] = useState(true);
	const [accordion4Open, setAccordion4Open] = useState(true);
	const [accordion5Open, setAccordion5Open] = useState(true);
	const [accordionCountryOpen, setAccordionCountryOpen] = useState(true);
	const [accordionPriorityOpen, setAccordionPriorityOpen] = useState(true);
	const [accordionDietaryOpen, setAccordionDietaryOpen] = useState(true)
	const [accordionPromotionOpen, setAccordionPromotionOpen] = useState(true);
	const [accordionSortOpen, setAccordionSortOpen] = useState(true);
	const [selectedItems, setSelectedItems] = useState([]);
	const [selectedItemBrand, setSelectedItemBrand] = useState([]);
	const [selectedItemCountry, setSelectedItemCountry] = useState([]);
	const [selectedItemSubCat, setSelectedItemSubCat] = useState([]);
	const [selectedItemDiet, setSelectedItemDiet] = useState([]);

	const [check, setCheck] = useState(false);
	const [priority, setPriority] = useState(false);
	const [promotion, setPromotion] = useState(false);
	const [selectedSort, setSelectedSort] = useState("");
	const [categoryList, setCategoryList] = useState([])
	const [subCategoryList, setSubCategoryList] = useState([])
	const [brandsList, setBrandsList] = useState([])
	const [countryList, setCountryList] = useState([])
	const [dietaryList, setDietaryList] = useState([])
    const [showMore, setShowMore] = useState(false);
    const maxVisible = 5;

    const handleShowMore = () => setShowMore(!showMore);

	const sortOptions = useMemo(() => {
		return [
			{ id: 0, label: "Sort", value: "" },
			{ id: 1, label: "Name (A to Z)", value: "a-z" },
			{ id: 2, label: "Name (Z to A)", value: "z-a" },
			{ id: 3, label: "Price (Low to High)", value: "low-high" },
			{ id: 4, label: "Price (High to Low)", value: "high-low" },
		];
	}, []);

	const handleChangeSort = (e) => {
		setSelectedSort(e.target.value);
	};

	const toggleAccordion1 = () => {
		setAccordion1Open(!accordion1Open);
		// setAccordion2Open(false);
		// setAccordion3Open(false);
		// setAccordion4Open(false);
		// setAccordion5Open(false);
	};

	const toggleAccordion2 = () => {
		setAccordion2Open(!accordion2Open);
		// setAccordion1Open(false);
		// setAccordion3Open(false);
		// setAccordion4Open(false);
		// setAccordion5Open(false);
	};

	const toggleAccordion3 = () => {
		setAccordion3Open(!accordion3Open);
		// setAccordion1Open(false);
		// setAccordion2Open(false);
		// setAccordion4Open(false);
		// setAccordion5Open(false);
	};
	const toggleAccordion4 = () => {
		setAccordion4Open(!accordion4Open);
		// setAccordion1Open(false);
		// setAccordion2Open(false);
		// setAccordion3Open(false);
		// setAccordion5Open(false);
	};
	const toggleAccordion5 = () => {
		setAccordion5Open(!accordion5Open);
		// setAccordion1Open(false);
		// setAccordion2Open(false);
		// setAccordion3Open(false);
		// setAccordion4Open(false);
	};

	const toggleAccordionDietary = () => {
		setAccordionDietaryOpen(!accordionDietaryOpen);
	};

	const toggleAccordionCountry = () => {
		setAccordionCountryOpen(!accordionCountryOpen);
	};

	const toggleAccordionPriority = () => {
		setAccordionPriorityOpen(!accordionPriorityOpen);
	};

	const toggleAccordionPromotion = () => {
		setAccordionPromotionOpen(!accordionPromotionOpen);
	};

	const toggleAccordionSort = () => {
		setAccordionSortOpen(!accordionSortOpen);
	};

	const [minValue, setMinValue] = useState("0");
	const [maxValue, setMaxValue] = useState("1000");

	const handleChange = (event) => {
		setMaxValue(event.target.value);
		if (window.location.pathname.split("/")[1] == "brand") {
			GetSub();
		}
		sortByAlphabetically();
		// onChange(event.target.value);
	};

	const [checkedFilter, setCheckedFilter] = useState([]);

	const handleSelectionCategory = (item) => {
		// toggleCheckbox()
		if (window.location.pathname.split("/")[1] == "brand") {
			GetSub();
		}
		// setBrandSelected([])
		// setCategorySelected([])
		const isCategoryPresent = categorySelected.length
			? categorySelected.find((cat, index) => cat.value === item.value)
			: null;
		if (!isCategoryPresent) {
			// setSelected((pre) => ({ ...pre, [`${item.value}`]: true }));
			setCategorySelected((pre) => [...pre, item]);
		} else {
			const newArr = categorySelected.filter((cat) => cat.value !== item.value);
			setCategorySelected(newArr);
		}
		// setSelectedItems((prev) => {
		//     return [...new Set([...prev, item.value])]
		// });
		setSelectedItems(() => {
			if (selectedItems.length && selectedItems.some((s) => s === item.value)) {
				let temp = [...selectedItems];
				temp = temp.filter((f) => f != item.value);
				return temp;
			} else {
				return [...selectedItems, item.value];
			}
		});
		sortByAlphabetically();
		// if (checkedFilter.includes(item)) {
		//     setCheckedFilter(checkedFilter.filter((selectedCat) => selectedCat !== item));
		// } else {
		//     setCheckedFilter([...checkedFilter, item]);
		// }
	};

	//sub categories
	const handleSelectionSubCategory = (item) => {
		// toggleCheckbox()
		if (window.location.pathname.split("/")[1] == "brand") {
			GetSub();
		}
		// setBrandSelected([])
		// setCategorySelected([])
		const isSubCategoryPresent = subCategorySelected.length
			? subCategorySelected.find((subCat, index) => subCat.value === item.value)
			: null;
		if (!isSubCategoryPresent) {
			// setSelected((pre) => ({ ...pre, [`${item.value}`]: true }));
			setSubCategorySelected((pre) => [...pre, item]);
		} else {
			const newArr = subCategorySelected.filter(
				(subCat) => subCat.value !== item.value
			);
			setSubCategorySelected(newArr);
		}
		// setSelectedItems((prev) => {
		//     return [...new Set([...prev, item.value])]
		// });
		setSelectedItemSubCat(() => {
			if (
				selectedItemSubCat.length &&
				selectedItemSubCat.some((s) => s === item.value)
			) {
				let temp = [...selectedItemSubCat];
				temp = temp.filter((f) => f != item.value);
				return temp;
			} else {
				return [...selectedItemSubCat, item.value];
			}
		});
		sortByAlphabetically();
		// if (checkedFilter.includes(item)) {
		//     setCheckedFilter(checkedFilter.filter((selectedCat) => selectedCat !== item));
		// } else {
		//     setCheckedFilter([...checkedFilter, item]);
		// }
	};

	const handleSelection = (item) => {
		// toggleCheckbox()
		if (window.location.pathname.split("/")[1] == "brand") {
			GetSub();
		}
		// setBrandSelected([])
		// setCategorySelected([])
		const isBrandPresent = brandSelected.length
			? brandSelected.find((brand, index) => brand.value === item.value)
			: null;
		if (!isBrandPresent) {
			// setSelected((pre) => ({ ...pre, [`${item.value}`]: true }));
			setBrandSelected((pre) => [...pre, item]);
		} else {
			const newArr = brandSelected.filter((brand) => brand.value !== item.value);
			setBrandSelected(newArr);
		}
		setSelectedItemBrand(() => {
			if (
				selectedItemBrand.length &&
				selectedItemBrand.some((s) => s === item.value)
			) {
				let temp = [...selectedItemBrand];
				temp = temp.filter((f) => f != item.value);
				return temp;
			} else {
				return [...selectedItemBrand, item.value];
			}
		});
		sortByAlphabetically();

		// if (checkedFilter.includes(item)) {
		//     setCheckedFilter(checkedFilter.filter((selectedBrand) => selectedBrand !== item));
		// } else {
		//     setCheckedFilter([...checkedFilter, item]);
		// }
	};

	const handleSelectCountry = (item) => {
		if (window.location.pathname.split("/")[1] === "brand") {
			GetSub();
		}
		const isCountryPresent = countrySelected.length
			? countrySelected.find((brand, index) => brand.value === item.value)
			: null;
		if (!isCountryPresent) {
			setCountrySelected((pre) => [...pre, item]);
		} else {
			const newArr = countrySelected.filter(
				(country) => country.value !== item.value
			);
			setCountrySelected(newArr);
		}
		setSelectedItemCountry(() => {
			if (
				selectedItemCountry.length &&
				selectedItemCountry.some((s) => s === item.value)
			) {
				let temp = [...selectedItemCountry];
				temp = temp.filter((f) => parseInt(f) !== parseInt(item.value));
				return temp;
			} else {
				return [...selectedItemCountry, item.value];
			}
		});
		sortByAlphabetically();
	};

	const handleSelectDietary = (item) => {
		if (window.location.pathname.split("/")[1] === "brand") {
			GetSub();
		}
		const isDietaryPresent = dietarySelected.length
			? dietarySelected.find((brand, index) => brand.value === item.value)
			: null;
		if (!isDietaryPresent) {
			setDietarySelected((pre) => [...pre, item]);
		} else {
			const newArr = dietarySelected.filter(
				(diet) => diet.value !== item.value
			);
			setDietarySelected(newArr);
		}
		setSelectedItemDiet(() => {
			if (
				selectedItemDiet.length &&
				selectedItemDiet.some((s) => s === item.value)
			) {
				let temp = [...selectedItemDiet];
				temp = temp.filter((f) => parseInt(f) !== parseInt(item.value));
				return temp;
			} else {
				return [...selectedItemDiet, item.value];
			}
		});
		sortByAlphabetically();
	};

	useEffect(() => {
		// setIsFilter(true);
		// setCheck(true);
		if (window.location.pathname.split("/")[1] == "brand") {
			GetSub();
		}
		sortByAlphabetically();
	}, [brandSelected, categorySelected]);
	
	useEffect(() => {
		sortByAlphabetically();
	}, [brands?.category, brands?.category, brands?.sub_category, brands?.brand, brands?.countries, brands?.dietary])

	const handleCheckAll = () => {
		const allBrands = brands.map((brand) => brand.name);
		setCheckedFilter(allBrands);
	};

	const handleUncheckAll = () => {
		setCheckedFilter([]);
	};

	const ApplyFilter = () => {
		// showModal()
		if (window.location.pathname.split("/")[1] == "brand") {
			GetSub();
		}
		setIsFilter(true);
		// setCheck(true);

		// useEffect(() => {
		setSelectedBrands(
			brandSelected,
			categorySelected,
			subCategorySelected,
			countrySelected,
			minValue,
			maxValue,
			isFilter,
			priority,
			promotion,
			selectedSort,
			check,
			dietarySelected
		);
		sortByAlphabetically();
		// setSelectedCategory(categorySelected);
		// setApplyFilter(!applyFilter)
		// }, []);
	};

	let history = useHistory();
	const location = useLocation();
	const [oldLocation,setOldLocation] = useState(window.location.pathname)
    // Replace the current URL with the new one, no page refresh
	const clearFilter = () => {
	setOldLocation(window.location.pathname)
    history.replace(oldLocation);
    setSelectedItemBrand([]);
    setBrandSelected([]);
    setSelectedItems([]);
    setCategorySelected([]);
    setSelectedItemSubCat([]);
    setSubCategorySelected([]);
		setSelectedItemCountry([]);
		setSelectedItemDiet([]);
		setDietarySelected([]);
		setCountrySelected([]);
    setMinValue("0");
    setMaxValue("1000");
    setIsFilter(false);
    setPriority(false);
    setPromotion(false);
    setSelectedSort("");
    setCheck(false);

    if (isFilter) {
	    setSelectedBrands([], [], [], [], "0", "1000", false, false, false, "", false, []);
      let timeout = setTimeout(() => {
		history.replace(oldLocation);
        resetFilters(dispatch);
      }, 1000);
      return () => clearTimeout(timeout);
    }
  };

	const handleInputChange = (event) => {
		let inputValue = parseInt(event.target.value);
		if (inputValue < 0) {
			inputValue = 0;
			alert("Value cannot be less than 0. Setting value to 0.");
		} else if (inputValue > 1000) {
			inputValue = 1000;
			alert("Value cannot be greater than 1000. Setting value to 1000.");
		}

		setMinValue(inputValue.toString());
	};
	const handleBlur = () => {
		if (minValue === "") {
			setMinValue("0");
		}
	};

	const toggleCheckbox = () => {
		if (!check === true) {
			setCheck(true);
		} else {
			setCheck(false);
		}
	};

	const togglePromotion = () => {
		setPromotion((prev) => !prev);
	};

	const togglePriority = () => {
		setPriority((prev) => !prev);
	};
	const brandTop5Quantity = () => {
		const sortedBrands = orderBy(brands?.brand, ['product_quantity'], ['desc']);
		const top5Brands = sortedBrands.slice(0, 5);
		const restBrands = orderBy(sortedBrands.slice(5), ['label'], ['asc']);
		const finalSortedBrands = [...top5Brands, ...restBrands];
		return finalSortedBrands;
	};
	const sortByAlphabetically = () => {
		setCategoryList(brands?.category?.slice()?.sort((a, b) => a.label.localeCompare(b.label)) || []);
		setSubCategoryList(brands?.sub_category?.slice()?.sort((a, b) => a.label.localeCompare(b.label)) || []);
		setBrandsList(brandTop5Quantity() || []);
		setCountryList(brands?.countries?.slice()?.sort((a, b) => a.label.localeCompare(b.label)) || []);
		setDietaryList(brands?.dietary?.slice()?.sort((a, b) => a.label.localeCompare(b.label)) || []);
	}

	useEffect(() => {	
		if (query && location.search) {
			setSelectedItemBrand(query?.brand_id || []);
			setBrandSelected(query?.brands || []);
			setSelectedItems(query?.cat_id || []);
			setCategorySelected(query?.category || []);
			setSelectedItemSubCat(query?.sub_cat_id||[]);
			setSubCategorySelected(query?.sub_category||[]);
			setSelectedItemCountry(query?.country_id || []);
			setCountrySelected(query?.country_id||[]);
			setMinValue(query?.min||0);
			setMaxValue(query?.max||1000);
			setIsFilter(true);
			setPriority(query?.priority || 0);
			setPromotion(query?.promotion || false);
			setSelectedSort(query?.sort || "a-z");
			setCheck(query?.oos == 1 ? true : false);
			setDietarySelected(query?.dietary || []);
			setSelectedItemDiet(query?.diet_id || []);
			handleChangeSort({target:{value:query?.sort}})

		}
		// sortByAlphabetically();
	}, [query]);
	//checked function
	return (
		<FilterWrapper>
			<AccordionWrapper>
				<div
					className="d-flex justify-content-between pt-2"
					style={{ height: "10%" }}
				>
					<div className="d-flex justify-content-between align-items-center">
						{/* <svg
							xmlns="http://www.w3.org/2000/svg"
							height="40"
							viewBox="0 -960 960 960"
							width="40"
						>
							<path d="M120-240v-60h240v60H120Zm0-210v-60h480v60H120Zm0-210v-60h720v60H120Z" />
						</svg> */}
						<Tune fontSize="large" className="text-secondary" />
						<h4 className="m-2 text-secondary ">Filter By</h4>
					</div>
					<CloseIcon onClick={showModal} className="close" />
				</div>
				<div className="body">
					<AccordionContainer>
						<AccordionHeader onClick={toggleAccordion1}>
							<AccordionTitle>{t("category_type")}</AccordionTitle>
							{accordion1Open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</AccordionHeader>
						{accordion1Open && (
							<AccordionContent>
								<div className="list_item">
									{categoryList.length
										? categoryList.map((category, index) => {
												return (
													<Form.Group controlId={"cat" + index} key={index}>
														<div className="item">
															<Form.Check
																inline
																label={category.label}
																id={"cat" + index}
																name="group1"
																type="checkbox"
																checked={selectedItems.some(
																	(value) => value == category?.value
																)}
																onChange={() => handleSelectionCategory(category)}
															/>
															{/* <span className="item_value">{category.qty? category.qty : null}</span> */}
														</div>
													</Form.Group>
												);
										  })
										: null}
								</div>
							</AccordionContent>
						)}
					</AccordionContainer>
					<AccordionContainer>
						<AccordionHeader onClick={toggleAccordion2}>
							<AccordionTitle>{t("sub_category_type")}</AccordionTitle>
							{accordion2Open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</AccordionHeader>
						{accordion2Open && (
							<AccordionContent>
								<div className="list_item">
									{subCategoryList.length
										? subCategoryList.map((sub_category, index) => {
												return (
													<Form.Group controlId={"subCat" + index} key={index}>
														<div className="item">
															<Form.Check
																inline
																label={sub_category.label}
																id={"subCat" + index}
																name="group2"
																type="checkbox"
																checked={selectedItemSubCat.some(
																	(value) => value == sub_category?.value
																)}
																onChange={() => handleSelectionSubCategory(sub_category)}
															/>
															{/* <span className="item_value">{sub_category.qty? sub_category.qty : null}</span> */}
														</div>
													</Form.Group>
												);
										  })
										: null}
								</div>
							</AccordionContent>
						)}
					</AccordionContainer>
					<AccordionContainer>
						<AccordionHeader onClick={toggleAccordion3}>
							<AccordionTitle>{t('list_brands')}</AccordionTitle>
							{accordion3Open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</AccordionHeader>
						{accordion3Open && (
							<AccordionContent>
								<div className="list_item">
									{/* Always show the first 5 items */}
									{brandsList.length ? (
										brandsList.slice(0, maxVisible).map((brand, index) => (
											<Form.Group controlId={index} key={index}>
												<div className="item">
													<Form.Check
														inline
														label={brand.label}
														name="group3"
														type="checkbox"
														id={index}
														checked={selectedItemBrand.some((value) => value == brand?.value)}
														onChange={() => handleSelection(brand)}
													/>
												</div>
											</Form.Group>
										))
									) : null}

									{/* Show remaining items if "See More" is clicked */}
									{showMore &&
										brandsList.slice(maxVisible).map((brand, index) => (
											<Form.Group controlId={index + maxVisible} key={index + maxVisible}>
												<div className="item">
													<Form.Check
														inline
														label={brand.label}
														name="group3"
														type="checkbox"
														id={index + maxVisible}
														checked={selectedItemBrand.some((value) => value == brand?.value)}
														onChange={() => handleSelection(brand)}
													/>
												</div>
											</Form.Group>
										))}

									{/* "See More" or "See Less" button */}
									{brandsList.length > maxVisible && (
										<SeeMoreButton>
											<a className="see-more" onClick={handleShowMore}>
												{showMore ? 'See Less' : 'See More'}
											</a>
										</SeeMoreButton>
									)}
								</div>
							</AccordionContent>
						)}
					</AccordionContainer>
					{(dietaryList.length && dietaryList.length > 0) ?
						<AccordionContainer>
							<AccordionHeader onClick={toggleAccordionDietary}>
								<AccordionTitle>{t("dietary_preference")}</AccordionTitle>
								{accordionDietaryOpen ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
							</AccordionHeader>
							{accordionDietaryOpen && (
								<AccordionContent>
									<div className="list_item">
										{/* Always show the first 5 items */}
										{dietaryList.map((diet, index) => (
											<Form.Group controlId={"diet" + index} key={index}>
												<div className="item">
													<Form.Check
														inline
														label={diet.label}
														name="group4"
														type="checkbox"
														id={"diet" + index}
														checked={selectedItemDiet.some((value) => value == diet?.value)}
														onChange={() => handleSelectDietary(diet)}
													/>
												</div>
											</Form.Group>
										))}
									</div>
								</AccordionContent>
							)}
						</AccordionContainer>
						: null
					}
					{countryList.length ? (
						<AccordionContainer>
							<AccordionHeader onClick={toggleAccordionCountry}>
								<AccordionTitle>{t('list_country')}</AccordionTitle>
								{accordionCountryOpen ? (
									<KeyboardArrowUpIcon />
								) : (
									<KeyboardArrowDownIcon />
								)}
							</AccordionHeader>
							{accordionCountryOpen && (
								<AccordionContent>
									<div className="list_item">
										{countryList.map((country) => {
											return (
												<Form.Group controlId={country.code} key={country.code}>
													<div className="item">
														<Form.Check
															inline
															label={
																<div style={{ display: "flex", gap: 5 }}>
																	<span>
																		<FlagIcon
																			code={country.code.toLowerCase()}
																			className="shadow"
																		/>
																	</span>
																	{country.label}
																</div>
															}
															name="group4"
															type="checkbox"
															id={country.code}
															checked={selectedItemCountry.some(
																(value) => parseInt(value) === parseInt(country?.value)
															)}
															onChange={() => handleSelectCountry(country)}
														/>
													</div>
												</Form.Group>
											);
										})}
									</div>
								</AccordionContent>
							)}
						</AccordionContainer>
					) : null}
					<AccordionContainer>
						<AccordionHeader onClick={toggleAccordionPromotion}>
							<AccordionTitle>{t('promotion')}</AccordionTitle>
							{accordionPromotionOpen ? (
								<KeyboardArrowUpIcon />
							) : (
								<KeyboardArrowDownIcon />
							)}
						</AccordionHeader>
						{accordionPromotionOpen && (
							<AccordionContent>
								<div className="d-flex align-items-center">
									<label className="w-100 d-flex justify-content-between align-items-center">
										<span style={{ cursor: "pointer" }}>{t('show_only_discounted_products')}</span>
										<Switch
											className={`react-switch ${!!promotion ? "active" : ""}`}
											onChange={togglePromotion}
											checked={!!promotion}
										/>
									</label>
								</div>
							</AccordionContent>
						)}
					</AccordionContainer>
					{/* <AccordionContainer>
						<AccordionHeader onClick={toggleAccordionPriority}>
							<AccordionTitle>Priority</AccordionTitle>
							{accordionPriorityOpen ? (
								<KeyboardArrowUpIcon />
							) : (
								<KeyboardArrowDownIcon />
							)}
						</AccordionHeader>
						{accordionPriorityOpen && (
							<AccordionContent>
								<div className="d-flex align-items-center">
									<label className="w-100 d-flex justify-content-between align-items-center">
										<span style={{ cursor: "pointer" }}>Show Products of Priority</span>
										<Switch
											className={`react-switch ${!!priority ? "active" : ""}`}
											onChange={togglePriority}
											checked={!!priority}
										/>
									</label>
								</div>
							</AccordionContent>
						)}
					</AccordionContainer> */}
					<AccordionContainer>
						<AccordionHeader onClick={toggleAccordion4}>
							<AccordionTitle>{t('show_out_of_stock')}</AccordionTitle>
							{accordion4Open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</AccordionHeader>
						{accordion4Open && (
							<AccordionContent>
								<div className="d-flex align-items-center">
									<label className="w-100 d-flex justify-content-between align-items-center">
										<span style={{ cursor: "pointer" }}>
											{t("shop_item_show_out_of_stock_option_title")}
										</span>
										<Switch
											className={`react-switch ${!!check ? "active" : ""}`}
											onClick={toggleCheckbox}
											onChange={toggleCheckbox}
											checked={!!check}
										/>
									</label>
								</div>
							</AccordionContent>
						)}
					</AccordionContainer>
					<AccordionContainer>
						<AccordionHeader onClick={toggleAccordionSort}>
							<AccordionTitle>{t('sort')}</AccordionTitle>
							{accordionSortOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</AccordionHeader>
						{accordionSortOpen && (
							<AccordionContent>
								<Form.Group controlId="formCreateEditOS">
									<Form.Control
										as="select"
										value={selectedSort}
										defaultValue={selectedSort}
										onChange={(e) => handleChangeSort(e)}
									>
										{sortOptions.map((os) => {
											return (
												<option key={os?.id} value={os?.value}>
													{os?.label}
												</option>
											);
										})}
									</Form.Control>
								</Form.Group>
							</AccordionContent>
						)}
					</AccordionContainer>
					<AccordionContainer>
						<AccordionHeader onClick={toggleAccordion5}>
							<AccordionTitle>{t('price_range')}</AccordionTitle>
							{accordion5Open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</AccordionHeader>
						{accordion5Open && (
							<AccordionContent>
								<div className="range-input-container">
									<input
										type="range"
										min={0}
										max={1000}
										defaultValue={1000}
										onChange={handleChange}
										className="range-input"
									/>

									<div className="range-value-container">
										<div className="d-block  m-1">
											<h6>Min</h6>
											<input
												type="number"
												className="form-control m-1"
												defaultValue={minValue||0}
												value={minValue}
												max={1000}
												onChange={handleInputChange}
												onBlur={handleBlur}
											></input>
										</div>
										<div className="d-block  m-1">
											<h6>Max</h6>
											<input
												type="number"
												className="form-control m-1"
												defaultValue={1000}
												value={maxValue}
												onChange={(e) => {
													const newValue = e.target.value;
													if (newValue <= 1000) {
														setMaxValue(newValue);
													}
												}}
											></input>
										</div>
									</div>
								</div>
							</AccordionContent>
						)}
					</AccordionContainer>
				</div>
				<div className="btn_filter_wrapper">
					<Button
						variant="contained"
						className="btn_filter clear_filter_btn"
						disabled={loading}
						onClick={clearFilter}
					>
						{t("shop_item_filter_clear_button")}
					</Button>
					<Button
						variant="contained"
						className="btn_filter apply_filter_btn"
						disabled={loading}
						onClick={ApplyFilter}
					>
						{loading ? (
							<Spinner animation="border" size="sm" />
						) : (
							<span>{t('apply_filter')}</span>
						)}
					</Button>
				</div>
			</AccordionWrapper>
		</FilterWrapper>
	);
};

export default SidebarFilter;
